"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _reactScrollTrigger = _interopRequireDefault(require("react-scroll-trigger"));
var _carouselImages = _interopRequireDefault(require("../styles/carousel-images.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var DesktopButtons = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(DesktopButtons, _Component);
  function DesktopButtons(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      isClient: false,
      hasTouchControls: false,
      didFadeIn: false
    };
    _this.onScrollProgress = _this.onScrollProgress.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = DesktopButtons.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      isClient: true,
      // Check for availability of touch controls in client's browser
      hasTouchControls: matchMedia('(hover: none), (pointer: coarse)').matches
    });
  };
  _proto.onScrollProgress = function onScrollProgress(scrollInfo) {
    var interestPeriod = 0.4;
    var didFadeIn = this.state.didFadeIn;
    if (!didFadeIn && scrollInfo.progress > interestPeriod) {
      this.setState({
        didFadeIn: true
      });
    }
  };
  _proto.render = function render() {
    var _this$state = this.state,
      isClient = _this$state.isClient,
      hasTouchControls = _this$state.hasTouchControls,
      didFadeIn = _this$state.didFadeIn;
    if (!isClient || hasTouchControls) return null;
    var _this$props = this.props,
      handleSlidePrev = _this$props.handleSlidePrev,
      handleSlideNext = _this$props.handleSlideNext,
      theme = _this$props.theme,
      label = _this$props.label,
      visibleSlideIndex = _this$props.visibleSlideIndex,
      carouselSlidesLength = _this$props.carouselSlidesLength;
    return /*#__PURE__*/_react["default"].createElement(_reactScrollTrigger["default"], {
      throttleScroll: 50,
      onProgress: this.onScrollProgress
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _carouselImages["default"].desktopControls + " " + (didFadeIn ? _carouselImages["default"].navigationAnimateIn : '')
    }, /*#__PURE__*/_react["default"].createElement("button", {
      onClick: function onClick() {
        return handleSlidePrev(visibleSlideIndex, carouselSlidesLength, -1);
      },
      type: "button",
      id: label,
      label: "Previous",
      "aria-label": "Previous",
      disabled: carouselSlidesLength <= 1,
      className: theme.mmcIconArrowLeftBig + " " + _carouselImages["default"].arrow + " "
    }), /*#__PURE__*/_react["default"].createElement("button", {
      onClick: function onClick() {
        return handleSlideNext(visibleSlideIndex, carouselSlidesLength, 1);
      },
      type: "button",
      id: label,
      label: "Next",
      "aria-label": "Next",
      disabled: carouselSlidesLength <= 1,
      className: theme.mmcIconArrowLeftBig + " " + _carouselImages["default"].arrow + " " + _carouselImages["default"].nextArrow
    })));
  };
  return DesktopButtons;
}(_react.Component);
exports["default"] = DesktopButtons;
DesktopButtons.displayName = 'DesktopControls';